// Helpers commerciaux partagés (format monétaire dynamique, libellés). Aucune devise codée en dur :
// les décimales proviennent du référentiel ISO 4217 ; défaut 2.
import i18n, { intlLocaleFor } from "../i18n";

export const CURRENCY_DECIMALS = {
  XPF: 0, XOF: 0, XAF: 0, JPY: 0, KRW: 0, CLP: 0, ISK: 0, VND: 0, VUV: 0, PYG: 0,
  RWF: 0, UGX: 0, GNF: 0, KMF: 0, DJF: 0, BIF: 0,
  BHD: 3, KWD: 3, OMR: 3, TND: 3, JOD: 3,
};

export const currencyDecimals = (cur) => {
  const c = (cur || "").toUpperCase();
  return CURRENCY_DECIMALS[c] != null ? CURRENCY_DECIMALS[c] : 2;
};

export const currencySymbol = (cur) => {
  const c = (cur || "").toUpperCase();
  if (c === "EUR") return "€";
  if (c === "XPF") return "F CFP";
  if (c === "USD") return "$";
  if (c === "GBP") return "£";
  if (c === "JPY") return "¥";
  return c; // code ISO comme symbole par défaut (ex. AUD, NZD, CAD)
};

const nf = (decimals) =>
  new Intl.NumberFormat(intlLocaleFor(i18n.language), { minimumFractionDigits: decimals, maximumFractionDigits: decimals });

export function formatMinor(minor, currency) {
  if (minor === null || minor === undefined || minor === "") return "—";
  const d = currencyDecimals(currency);
  const value = d === 0 ? minor : minor / Math.pow(10, d);
  return `${nf(d).format(value)} ${currencySymbol(currency)}`;
}

export function minorToInput(minor, currency) {
  if (minor === null || minor === undefined || minor === "") return "";
  const d = currencyDecimals(currency);
  if (d === 0) return String(minor);
  return String(minor / Math.pow(10, d)).replace(".", ",");
}

export function parseToMinor(str, currency) {
  if (str === null || str === undefined) return null;
  const norm = String(str).replace(/\s/g, "").replace(",", ".");
  if (norm === "") return null;
  const num = parseFloat(norm);
  if (isNaN(num)) return null;
  const d = currencyDecimals(currency);
  return d === 0 ? Math.round(num) : Math.round(num * Math.pow(10, d));
}

export function numOrDash(v) {
  if (v === null || v === undefined || v === "") return "Illimité / sur mesure";
  return String(v);
}

export function fmtDate(v) {
  if (!v) return "—";
  try {
    return new Date(v).toLocaleString(intlLocaleFor(i18n.language), { dateStyle: "medium", timeStyle: "short" });
  } catch (e) {
    return "—";
  }
}

export const PLAN_KEYS = ["free", "pro", "team", "business", "enterprise"];
export const PLAN_LABELS = { free: "Gratuit", pro: "Pro", team: "Team", business: "Business", enterprise: "Entreprise" };

export const BILLING_OPTIONS = [
  ["free", "Gratuit"],
  ["flat", "Forfait fixe"],
  ["per_user", "Par utilisateur"],
  ["usage", "À l'usage"],
  ["custom", "Personnalisé"],
];
export const BILLING_LABELS = Object.fromEntries(BILLING_OPTIONS);

export const EXP_OPTIONS = [
  ["10m", "10 minutes"],
  ["1h", "1 heure"],
  ["4h", "4 heures"],
  ["24h", "24 heures"],
  ["7d", "7 jours"],
  ["30d", "30 jours"],
];
export const EXP_LABELS = Object.fromEntries(EXP_OPTIONS);

export const CAP_FIELDS = [
  ["can_use_branding", "Personnalisation de marque"],
  ["can_use_custom_domain", "Domaines personnalisés"],
  ["can_use_api", "API"],
  ["can_use_webhooks", "Webhooks"],
  ["can_use_secure_requests", "Demandes sécurisées"],
  ["can_use_recipient_otp", "Vérification destinataire par code"],
  ["can_use_sms_delivery", "Envoi SMS"],
  ["can_use_sso", "SSO"],
];

export const INC_FIELDS = [
  ["includes_webhooks", "Webhooks"],
  ["includes_recipient_otp", "Vérification destinataire par code"],
  ["includes_sms_delivery", "Envoi SMS"],
  ["includes_sso", "SSO"],
];

// Champs autorisés par le modèle backend _PlanDraftIn (extra="forbid").
export const DRAFT_FIELDS = [
  "name", "active", "visible", "display_order", "billing_model",
  "included_members", "additional_member_price_minor", "self_service_max_members",
  "monthly_secret_soft_limit", "monthly_secret_hard_limit", "monthly_secure_request_limit",
  "history_retention_days", "max_expiration", "max_custom_domains",
  "can_use_branding", "can_use_custom_domain", "can_use_api", "can_use_webhooks",
  "can_use_secure_requests", "can_use_recipient_otp", "can_use_sms_delivery", "can_use_sso",
  "includes_webhooks", "includes_recipient_otp", "includes_sms_delivery", "includes_sso",
  "requires_quote", "pricing",
];
